import { render, staticRenderFns } from "./location-statistics.vue?vue&type=template&id=61c9c4e5"
import script from "./location-statistics.vue?vue&type=script&lang=ts"
export * from "./location-statistics.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports